module.exports = __webpack_public_path__ + "static/media/happy_turtle.1bfaff90.svg";